import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

const YAMLParserNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const operation = data.config?.operation || 'parse';

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-cyan-400 to-cyan-500 border-2 transition-all duration-200 ${
      selected ? 'border-cyan-600 shadow-xl scale-105' : 'border-cyan-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentDuplicateIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-cyan-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Operation display */}
          <div className="flex items-center mt-1 space-x-2">
            <span className="text-xs text-cyan-100">
              {operation === 'parse' ? '📋 YAML → JSON' : '📄 JSON → YAML'}
            </span>
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution result */}
      {data.executionData?.parsed && (
        <div className="mt-2 text-xs text-cyan-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <strong>Státusz:</strong> ✅ Feldolgozva
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-cyan-600 border-2 border-white"
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-cyan-600 border-2 border-white"
      />
    </div>
  );
};

export default YAMLParserNode;
